import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const Label = styled.div`
	display: flex;
	color: #333333;
	margin-right: 16px;
	font-size: 19px;
	font-weight: 500;
	letter-spacing: 0px;
`;
